import Vue from "vue"
import SortedTablePlugin from "vue-sorted-table"
import Paginate from "@/components/widgets/pagination.vue";
import DepositDocuments from "@/components/widgets/depositdocuments";
const _ = require('lodash')

Vue.use(SortedTablePlugin, {
  ascIcon: '<i class="mdi mdi-arrow-down"></i>',
  descIcon: '<i class="mdi mdi-arrow-up"></i>'
})

export default { 
  props: {
    width: {
      type: String,
      default: 'w-50 m-auto'
    },
    show: {
      type: Boolean,
      default: false
    },
    uuid: {
      type: String,
      default: ""
    },
    isDynamic: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Paginate,
    DepositDocuments
  },
  data() {
    return {
      depositDocumentEnabled: false,
      deposit_document_id: null,
      deposit_document_no: '',

      customer_id: null,
      show_price: 1,
      remark: "",
      selectedRows: [],
      busy: false,
      textInput: '',
      answer: 'ค้นหาจาก รหัสคอยล์ ชื่อคอยล์',
      totalItem: 0,
      perPage: 8,
      sortBy: 'name',
      currentPage: 1,
      currentData: {},
      sortDesc: false,
      sortByFormatted: true,
      filterByFormatted: true,
      sortable: true,
      fields: [
        {
          key: "index",
          label: "#",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "font-weight-light text-xs-1/2",
          sortable: false,
        },
        {
          key: "code",
          label: "รหัสสินค้า",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "font-weight-light text-xs-1/2",
          sortable: false,
        },
        {
          key: "description",
          label: "รายละเอียด",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "font-weight-light text-xs-1/2",
          sortable: false,
        },
        {
          key: "length",
          label: "ความยาว",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "text-gray-400 font-weight-light text-xs-1/2",
          sortable: false,
        },
        {
          key: "quantity",
          label: "จำนวน",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "text-gray-400 font-weight-light text-xs-1/2",
          sortable: false,
        },
        {
          key: "unit_name",
          label: "หน่วย",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "text-gray-400 font-weight-light text-xs-1/2",
          sortable: false,
        },
        {
          key: "total_length",
          label: "ปริมาณรวม",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "text-gray-400 font-weight-light text-xs-1/2",
          sortable: false,
        },
        {
          key: "unit_price",
          label: "ราคาต่อหน่อย",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "text-gray-400 font-weight-light text-xs-1/2",
          sortable: false,
        },
        {
          key: "total_price",
          label: "ราคารวม",
          thClass: "text-xs-1/2 font-weight-bold",
          tdClass: "text-gray-400 font-weight-light text-xs-1/2",
          sortable: false,
        },
        // {
        //   key: "total_send",
        //   label: "ปริมาณที่จะส่ง",
        //   thClass: "text-xs-1/2 font-weight-bold",
        //   tdClass: "text-gray-400 font-weight-light text-xs-1/2",
        //   sortable: false,
        // },
      ],
      items: [],
      bill_tax_type: 0,
      quotation_vat_type: null, // ประเภท VAT จากใบเสนอราคา (ไว้เทียบตอนแปลงเป็นบิล)
      bill_discount_amt: 0,
      bill_deposit_amt: 0,
      deposit_incl_vat: 0,
      discount: 0,
      deposit: 0,
      only_product_items: [],
      is_complete_delivery: false,
     }
  },
  computed: {
    rows() {
      return this.items.length
    },
    subtotal() {
      const total = this.selectedRows.reduce((total, obj) => obj.total_price + total,0)
      if (this.bill_tax_type === 2) {
        return parseFloat(total);
      } else {
        return total;
      }
    },
    before_vat: function () {
      const total = this.selectedRows.reduce((accumulator, object) => {
        return parseFloat(accumulator) + parseFloat(object.total_price);
      }, 0);
      const afterDeposit = total - this.bill_discount_amt - this.depositInBase();
      if (this.bill_tax_type === 2) {
        return (afterDeposit * 100) / 107; // รวมใน: ถอด VAT จากยอดหลังหักมัดจำ
      } else {
        return afterDeposit; // แยกนอก / ไม่มี VAT: ฐานก่อน VAT
      }
    },
    vat(){
      const total = this.selectedRows.reduce((total, obj) => obj.total_price + total,0)
      const afterDeposit = total - this.bill_discount_amt - this.depositInBase();
      if (this.bill_tax_type === 1) {
        return afterDeposit * 0.07;
      } else if (this.bill_tax_type === 2) {
        return (afterDeposit * 7) / 107;
      } else {
        return 0;
      }
    },
    total() {
      const total = this.selectedRows.reduce((total, obj) => obj.total_price + total,0)
      const afterDeposit = total - this.bill_discount_amt - this.depositInBase();
      if (this.bill_tax_type === 1) {
        return afterDeposit * 1.07; // แยกนอก: บวก VAT จากยอดหลังหักมัดจำ
      } else if (this.bill_tax_type === 2) {
        return afterDeposit; // รวมใน: grand รวม VAT แล้ว
      } else {
        return afterDeposit;
      }
    }
  },
  watch: {
    show: function (newValue, oldValue) {
      if (newValue) {
        this.bill_tax_type = 0
        this.selectedRows = []
        this.loadItems(this.uuid)
        // this.onSearchHandler(this.currentPage)
      }
    },
    items(new_val) {
      if (new_val) {
        this.only_product_items = this.items.filter(
          (x) => x.type === 1
        )
      }
    },
  },
  methods: {
    // เกณฑ์ A: มัดจำที่หักจากฐานยอด ในฐาน VAT เดียวกับบิล
    // ยึด deposit_incl_vat (สุทธิ) — บิลแยก VAT (tax1) ถอด VAT = incl/1.07 | tax2/0 หักสุทธิตรงๆ
    // fallback: ใบเก่าไม่มี deposit_incl_vat → ใช้ bill_deposit_amt ตรงๆ (ถือว่าอยู่ฐานบิลแล้ว)
    depositInBase() {
      const incl = parseFloat(this.deposit_incl_vat) || 0;
      if (incl > 0) {
        // คิดตามฐาน VAT ของบิลเสมอ: แยก VAT (1) ถอด VAT ก่อน | รวม VAT (2)/ไม่มี VAT (0) หักสุทธิตรงๆ
        return parseInt(this.bill_tax_type) === 1 ? Number((incl * 100 / 107).toFixed(2)) : incl;
      }
      return parseFloat(this.bill_deposit_amt) || 0;
    },
    onInitDepositDocumentSettings(e) {
      this.depositDocumentEnabled = false;
      if (e.status) {
        const data = e.data;
        // เตือนเมื่อ VAT ของเอกสารมัดจำไม่ตรงกับบิล (ไม่ block — ยืนยันแล้วใช้ต่อได้)
        if (
          data.tax_type != null &&
          parseInt(data.tax_type) !== parseInt(this.bill_tax_type)
        ) {
          const vatText = (v) => {
            const map = { 0: "ไม่มี VAT", 1: "แยก VAT", 2: "รวม VAT" };
            return map[parseInt(v)] != null ? map[parseInt(v)] : v;
          };
          this.$swal({
            width: "29rem",
            padding: "1.825em",
            html:
              '<div class="d-flex flex-row align-items-center">' +
              '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
              '<div class="d-flex flex-column">' +
              '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>' +
              '<span class="text-base text-left text-gray-500">ประเภท VAT ของเอกสารมัดจำ (' +
              vatText(data.tax_type) +
              ") ไม่ตรงกับบิล (" +
              vatText(this.bill_tax_type) +
              ") ต้องการดำเนินการต่อหรือไม่?</span>" +
              "</div>" +
              "</div>",
            allowOutsideClick: false,
            focusConfirm: false,
            customClass: {
              popup: "swal2-custom-rounded",
              closeButton: "text-3xl swal2-custom-close",
              actions: "justify-content-end",
              contant: "d-flex flex-row justify-content-around px-2",
              title: "d-none",
              confirmButton:
                "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
              cancelButton:
                "btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
            },
            cancelButtonColor: "#dc4a38",
            cancelButtonText: "ยกเลิก",
            confirmButtonText: "ดำเนินการต่อ",
            showCancelButton: true,
            showCloseButton: true,
            // บังคับให้ลอยเหนือ modal (.modal-mask z-index 5000) กันโดนบัง (swal2 v8 ใช้ onOpen)
            onOpen: () => {
              const c = document.querySelector(".swal2-container");
              if (c) c.style.zIndex = "999999";
            },
          }).then((confirm) => {
            if (confirm.value) {
              this.applyDepositDocument(data);
            }
            this.show = true;
          });
          return;
        }
        this.applyDepositDocument(data);
      }
      this.show = true
    },
    applyDepositDocument(data) {
      // มัดจำ: เก็บสุทธิ (grand_total) — depositInBase จะถอด VAT ตามฐานบิลเอง
      const incl = data.grand_total != null ? parseFloat(data.grand_total) : parseFloat(data.amount)
      this.deposit_incl_vat = incl
      // หักมัดจำ (แสดง) = ฐานเดียวกับที่ใช้คำนวณยอด — คิดตาม VAT ของบิลผ่าน depositInBase()
      this.bill_deposit_amt = this.depositInBase()
      this.deposit_document_id = data.id
      this.deposit_document_no = data.document_no
    },
    isRowSelected(item) {
      return false
      // return this.selectedRows.some(row => row.id === item.id); // Check if row is selected
    },
    checkSentAmount(event, item) {
      let value = parseFloat(event); // Get the input value as a number

      if (isNaN(value) || value < 0) {
        item.total_send = 0; // Reset to 0 if negative or invalid
        return
      }

      // งานล่ำซำ: ไม่จำกัดจำนวน
      if (this.isDynamic) {
        item.total_send = value.toFixed(2)
        return
      }

      let maxValue = parseFloat(item.total_length - item.sent_amount); // Get max allowed value
      if (value > maxValue) {
        item.total_send = maxValue.toFixed(2); // Enforce max limit with 2 decimals
      } else {
        item.total_send = value.toFixed(2); // Always format to 2 decimal places
      }
    },
    onClose () {
      this.$emit('onPopupCloseHandler', {
        status: false
      })
    },
    onSelected() {
      // เตือนเมื่อประเภท VAT ของบิลไม่ตรงกับใบเสนอราคา (ไม่ block — ยืนยันแล้วทำต่อได้)
      if (
        this.quotation_vat_type !== null &&
        parseInt(this.bill_tax_type) !== this.quotation_vat_type
      ) {
        const vatText = (v) => {
          const map = { 0: "ไม่มี VAT", 1: "แยก VAT", 2: "รวม VAT" };
          return map[parseInt(v)] != null ? map[parseInt(v)] : v;
        };
        this.$swal({
          width: "29rem",
          padding: "1.825em",
          html:
            '<div class="d-flex flex-row align-items-center">' +
            '<i class="fa fa-2x mr-3 fa-exclamation-triangle text-info"></i>' +
            '<div class="d-flex flex-column">' +
            '<span class="font-bold text-base py-2.5 text-left">แจ้งเตือน</span>' +
            '<span class="text-base text-left text-gray-500">ประเภท VAT ของบิล (' +
            vatText(this.bill_tax_type) +
            ") ไม่ตรงกับใบเสนอราคา (" +
            vatText(this.quotation_vat_type) +
            ") ต้องการดำเนินการต่อหรือไม่?</span>" +
            "</div>" +
            "</div>",
          allowOutsideClick: false,
          focusConfirm: false,
          customClass: {
            popup: "swal2-custom-rounded",
            closeButton: "text-3xl swal2-custom-close",
            actions: "justify-content-end",
            contant: "d-flex flex-row justify-content-around px-2",
            title: "d-none",
            confirmButton:
              "btn btn-info py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
            cancelButton:
              "btn btn-google py-3 rounded-lg text-white font-prompt-light text-sm font-normal",
          },
          cancelButtonColor: "#dc4a38",
          cancelButtonText: "ยกเลิก",
          confirmButtonText: "ดำเนินการต่อ",
          showCancelButton: true,
          showCloseButton: true,
          // บังคับให้ลอยเหนือ modal (.modal-mask z-index 5000) กันโดนบัง (swal2 v8 ใช้ onOpen)
          onOpen: () => {
            const c = document.querySelector(".swal2-container");
            if (c) c.style.zIndex = "999999";
          },
        }).then((confirm) => {
          if (confirm.value) {
            this.emitSelected();
          }
        });
        return;
      }
      this.emitSelected();
    },
    emitSelected() {
      this.$emit('onPopupCloseHandler', {
        status: true,
        uuid: this.uuid,
        show_price: this.show_price,
        remark: this.remark,

        subtotal: this.subtotal,
        discount: this.bill_discount_amt,
        before_vat: this.before_vat,
        vat: this.vat,
        vatable: this.bill_tax_type,
        deposit: this.bill_deposit_amt,
        total: this.total,

        deposit_document_id: this.deposit_document_id,
        deposit_document_no: this.deposit_document_no,

        is_complete_delivery: this.is_complete_delivery,
        is_dynamic: this.isDynamic,

        data: this.selectedRows,
      })
    },
    onRowSelected(items) {
      this.selectedRows = items;
      const selectedItemButOnlyProduct = items.filter(
        (x) => x.type === 1
      )
      const isAllSelected = (JSON.stringify(selectedItemButOnlyProduct) === JSON.stringify(this.only_product_items))
      if(isAllSelected){
        // this.bill_deposit_amt = this.deposit
        this.bill_discount_amt = this.discount
        // งานล่ำซำ: ไม่ปิดบิล แม้เลือกครบ (ให้สร้างต่อได้เรื่อยๆ)
        this.is_complete_delivery = !this.isDynamic
      }
      else{
        this.bill_deposit_amt = 0
        this.deposit_incl_vat = 0
        this.bill_discount_amt = 0
        this.deposit_document_id = null
        this.deposit_document_no = ''
        this.is_complete_delivery = false
      }
    },
    // async onSearchHandler (currentPage) {
      
    //   // this.loading = true
    //   // this.items = []
    //   this.busy = true
    //   this.apiStatus = 'กำลังค้นหาข้อมูล..'
    //   const page = currentPage ? currentPage : 1
    //   const result = await Vue.prototype.$axios.get(`${Vue.prototype.$host}/api/v1/branchstock?page=${page}&perPage=8&keyword=${this.textInput}`)
    //   setTimeout(() => {
    //     // this.loading = false
    //     this.currentData = result.data
    //     this.items = result.data.data
    //     this.totalItem = result.data.total
    //     this.apiStatus = 'ไม่พบข้อมูล.'
    //     this.busy = false
    //     if (result) {
    //       this.items = result.data.data
    //     } else {
    //       this.apiStatus = 'ไม่พบข้อมูล'
    //       this.onExceptionHandler()
    //     }
    //   }, 500)
    // }
    selectAllRows () {
      this.$refs.mytable.selectAllRows()
    },
    clearTableSelected () {
      this.$refs.mytable.clearSelected()
    },
    async loadItems(q) {
      this.loading = true
      this.busy = true;
      try {
        const result = await this.$axios.get(
          `${this.$host}/api/v1/bill-item/${q}`
        );
        if (result) {
          const data = result.data;

          this.bill_tax_type = data.bill_tax_type
          this.quotation_vat_type =
            data.quotation_vat_type != null
              ? parseInt(data.quotation_vat_type)
              : null
          this.discount = data.bill_discount_amt ? data.bill_discount_amt : 0
          this.deposit = data.bill_deposit_amt ? data.bill_deposit_amt : 0

          // data.data.map((item) => {
          //   item.roll = "";
          //   return item;
          // });

          this.items = data.data;

          this.customer_id = data.customer.id.toString()

          this.totalItem = data.data.length
        }
        this.loading = false
        this.busy = false;
      } catch (error) {
        this.loading = false
        this.busy = false;
        this.onExceptionHandler((error.response && error.response.data && error.response.data.message) || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
      }
    },
  }
}
